
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comunicati/c/[...slug]",
      function () {
        return require("private-next-pages/comunicati/c/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comunicati/c/[...slug]"])
      });
    }
  